/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { bodyPreview } from 'my-phorest/utils/whatsapp';

export default class WhatsappTemplateComponent extends Component {
  get templateBodyPreview() {
    return bodyPreview(this.args.body);
  }
}
